var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stripe_paint0_linear)",
    d: "M0 0h21v21H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48 2.379L0 3.773V0h6.48v2.379z",
    fill: "#6B49BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.719 10.254v8.039H21V9.598l-3.281.656z",
    fill: "url(#stripe_paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.605V21H21v-3.61l-10.5 2.215z",
    fill: "url(#stripe_paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.596 8.03c0-.518.425-.717 1.129-.717 1.01 0 2.285.305 3.295.85V5.041a8.761 8.761 0 00-3.295-.611c-2.697 0-4.49 1.408-4.49 3.76 0 3.666 5.048 3.082 5.048 4.663 0 .611-.531.81-1.275.81-1.103 0-2.511-.452-3.627-1.063v3.162a9.21 9.21 0 003.627.758c2.763 0 4.663-1.369 4.663-3.747-.013-3.959-5.075-3.255-5.075-4.743z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe_paint0_linear",
    x1: 5.742,
    y1: 3.938,
    x2: 18.457,
    y2: 19.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6856D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#559BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe_paint1_linear",
    x1: 19.359,
    y1: 9.598,
    x2: 19.359,
    y2: 18.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5794F1",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A6F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe_paint2_linear",
    x1: 10.5,
    y1: 21,
    x2: 21,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#6D9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.0c729addf708b7d00ce615d4494ee3cb.svg";
export { ForwardRef as ReactComponent };